// src/App.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar/Navbar"; // Global Navbar
import BottomBar from "./components/BottomBar/BottomBar"; // Global BottomBar
import Homepage from "./pages/Homepage/Homepage";
import Produse from "./pages/Produse/Produse";
import ProductPage from "./pages/ProductPage/ProductPage";
import LogIn from "./pages/LogIn/LogIn"; // Import the LogIn component
import Admin from "./pages/Admin/Admin";
import Orders from "./pages/Orders/Orders";
import MyCart from "./pages/MyCart/MyCart";
import Policy from "./pages/Policy/Policy";
import About from "./pages/About/About";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute"; // Importă ProtectedRoute
import { AuthProvider } from "./context/AuthContext"; // Asigură-te că AuthProvider este importat
import { CartProvider } from "./context/CartContext"; // Importă CartProvider

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        {" "}
        {/* Învelește aplicația cu CartProvider */}
        <div className="App">
          <header>
            <Navbar /> {/* Navbar primește cartCount din contextul global */}
          </header>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/produse" element={<Produse />} />
            <Route path="/item/:id" element={<ProductPage />} />
            <Route path="/login" element={<LogIn />} />
            <Route path="/cart" element={<MyCart />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/about" element={<About />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute requiredRole="admin">
                  <Orders />
                </ProtectedRoute>
              }
            />
          </Routes>
          <BottomBar />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
